let prefix = '/api/sales/cie';

function exportPdf(data){
    return window.axios.post(prefix+'/export-pdf',data,{ responseType: 'blob' });
}

export default {
    exportPdf
}